/**
 * Shared scrollbar styling for OC components
 * Provides consistent scrollbar appearance across the OC widget
 */

import { css } from 'styled-components';

/**
 * OC scrollbar styling as a CSS mixin
 * Can be used with styled-components' css helper
 */
export const ocScrollbarStyles = css`
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
  }
`;

